var endpointMap = {
	ar: {
		BADASGuidedPath: "translation-ar.json"
	},
	"ar-AE": {
		BADASGuidedPath: "translation-ar.json"
	},
	bn: {
		BADASGuidedPath: "translation-bn.json"
	},
	"bn-IN": {
		BADASGuidedPath: "translation-bn.json"
	},
	de: {
		BADASGuidedPath: "translation-de.json"
	},
	"de-DE": {
		BADASGuidedPath: "translation-de.json"
	},
	en: {
		BADASGuidedPath: "translation-en.json"
	},
	"en-AU": {
		BADASGuidedPath: "translation-en.json"
	},
	"en-CA": {
		BADASGuidedPath: "translation-en.json"
	},
	"en-GB": {
		BADASGuidedPath: "translation-en.json"
	},
	"en-IE": {
		BADASGuidedPath: "translation-en.json"
	},
	"en-IN": {
		BADASGuidedPath: "translation-en.json"
	},
	"en-SG": {
		BADASGuidedPath: "translation-en.json"
	},
	"en-US": {
		BADASGuidedPath: "translation-en.json"
	},
	"en-ZA": {
		BADASGuidedPath: "translation-en.json"
	},
	es: {
		BADASGuidedPath: "translation-es.json"
	},
	"es-ES": {
		BADASGuidedPath: "translation-es.json"
	},
	"es-MX": {
		BADASGuidedPath: "translation-es.json"
	},
	fr: {
		BADASGuidedPath: "translation-fr.json"
	},
	"fr-BE": {
		BADASGuidedPath: "translation-fr.json"
	},
	"fr-FR": {
		BADASGuidedPath: "translation-fr.json"
	},
	gu: {
		BADASGuidedPath: "translation-gu.json"
	},
	"gu-IN": {
		BADASGuidedPath: "translation-gu.json"
	},
	hi: {
		BADASGuidedPath: "translation-hi.json"
	},
	"hi-IN": {
		BADASGuidedPath: "translation-hi.json"
	},
	it: {
		BADASGuidedPath: "translation-it.json"
	},
	"it-IT": {
		BADASGuidedPath: "translation-it.json"
	},
	ja: {
		BADASGuidedPath: "translation-ja.json"
	},
	"ja-JP": {
		BADASGuidedPath: "translation-ja.json"
	},
	kn: {
		BADASGuidedPath: "translation-kn.json"
	},
	"kn-IN": {
		BADASGuidedPath: "translation-kn.json"
	},
	ko: {
		BADASGuidedPath: "translation-ko.json"
	},
	"ko-KR": {
		BADASGuidedPath: "translation-ko.json"
	},
	ml: {
		BADASGuidedPath: "translation-ml.json"
	},
	"ml-IN": {
		BADASGuidedPath: "translation-ml.json"
	},
	mr: {
		BADASGuidedPath: "translation-mr.json"
	},
	"mr-IN": {
		BADASGuidedPath: "translation-mr.json"
	},
	nl: {
		BADASGuidedPath: "translation-nl.json"
	},
	"nl-BE": {
		BADASGuidedPath: "translation-nl.json"
	},
	"nl-NL": {
		BADASGuidedPath: "translation-nl.json"
	},
	pl: {
		BADASGuidedPath: "translation-pl.json"
	},
	"pl-PL": {
		BADASGuidedPath: "translation-pl.json"
	},
	pt: {
		BADASGuidedPath: "translation-pt.json"
	},
	"pt-BR": {
		BADASGuidedPath: "translation-pt.json"
	},
	"pt-PT": {
		BADASGuidedPath: "translation-pt.json"
	},
	sv: {
		BADASGuidedPath: "translation-sv.json"
	},
	"sv-SE": {
		BADASGuidedPath: "translation-sv.json"
	},
	ta: {
		BADASGuidedPath: "translation-ta.json"
	},
	"ta-IN": {
		BADASGuidedPath: "translation-ta.json"
	},
	te: {
		BADASGuidedPath: "translation-te.json"
	},
	"te-IN": {
		BADASGuidedPath: "translation-te.json"
	},
	th: {
		BADASGuidedPath: "translation-th.json"
	},
	"th-TH": {
		BADASGuidedPath: "translation-th.json"
	},
	tr: {
		BADASGuidedPath: "translation-tr.json"
	},
	"tr-TR": {
		BADASGuidedPath: "translation-tr.json"
	},
	und: {
		BADASGuidedPath: "translation.json"
	},
	vi: {
		BADASGuidedPath: "translation-vi.json"
	},
	"vi-VN": {
		BADASGuidedPath: "translation-vi.json"
	},
	zh: {
		BADASGuidedPath: "translation-zh.json"
	},
	"zh-CN": {
		BADASGuidedPath: "translation-zh.json"
	},
	"zh-TW": {
		BADASGuidedPath: "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
